import React, { useEffect, useState } from 'react';
import { FaFilePdf, FaEdit, FaTrashAlt, FaFilter } from 'react-icons/fa';
import '../../Styles/Quotes.css';
import '../../Styles/UserTypes.css';
import Notification from '../../Login/Components/Notification';
import { fetchCustomerAndQuotes } from '../Services';
import { getPresignedUrl } from '../../Home/Services';
import moment from 'moment/moment';
import { Timeline } from '@mui/icons-material';


export default function Quotes() {
  const [user, setUser] = useState(null);
  const [quotesData, setQuotesData] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [filterCompanyName, setFilterCompanyName] = useState('');
  const [filterSolutionType, setFilterSolutionType] = useState('');
  const [filterTimeline, setFilterTimeline] = useState('');
  const [filterPrice, setFilterPrice] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [filterCreatedDate, setFilterCreatedDate] = useState('');
  const [filterCreatedBy, setFilterCreatedBy] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } 
  }, []); // Load user from localStorage once on mount
  
  useEffect(() => {
    // Wait for the user state to be set
    if (user && user.user_id) {
      const user_id = user.user_id; // Get the user_id
  
      const loadQuotesData = async () => {
        try {
          // Always send the user_id to the function
          const data = await fetchCustomerAndQuotes(user_id);
          
          const formattedData = data.map((item, index) => ({
            id: index + 1,
            
            company_name: item.company_name,
            solution: item.solution,
            time: item.timeline,
            price: item.price,
            value: item.values,
            pdfUrl: item.attachment,
            created_at: item.created_at,
            created_by: item.first_name,
            created_by_lastname: item.last_name,
            
          }));
  
          setQuotesData(formattedData);
        } catch (error) {
          console.error('Error fetching quotes:', error);
          setNotificationMessage('Failed to load quotes data');
          setShowNotification(true);
        }
      };
  
      loadQuotesData();
    }
  }, [user]); // This effect will run again when `user` changes
  

  const handleDownload = async (e, attachment) => {
    e.preventDefault();
    const env = process.env.REACT_APP_ENV;
    let bucket;
    if(env === 'dev') bucket = 'dev-neviton-app-quote';
    else if(env === 'prod') bucket = 'prod-neviton-app-quote';
    const key = `assets/${attachment}`
    const response = await getPresignedUrl(bucket, key);
    if (response && response.payLoad) {
      window.open(response.payLoad, '_blank'); // Open the presigned URL in a new tab
    }
  }

  const handleNotificationClose = () => setShowNotification(false);

  const filteredQuotes = quotesData.filter((quote) => {
    const companyNameFilter = filterCompanyName.trim().toLowerCase();
    const solutionTypeFilter = filterSolutionType.trim().toLowerCase();
    const timelineFilter = filterTimeline.trim().toLowerCase();
    const priceFilter = filterPrice.trim();
    const valueFilter = filterValue.trim();
    const createdDateFilter = filterCreatedDate.trim();
    const createdByFilter = filterCreatedBy.trim().toLowerCase();

    const matchesCompanyName = companyNameFilter
      ? quote.company_name && quote.company_name.toLowerCase().includes(companyNameFilter)
      : true;

    const matchesSolutionType = solutionTypeFilter
      ? quote.solution && quote.solution.toLowerCase().includes(solutionTypeFilter)
      : true;

    const matchesTimeline = timelineFilter
      ? quote.time && quote.time.toLowerCase().includes(timelineFilter)
      : true;

    const matchesPrice = priceFilter
      ? quote.price && quote.price.toString().includes(priceFilter)
      : true;

    const matchesValue = valueFilter
      ? quote.value && quote.value.toString().includes(valueFilter)
      : true;

    const matchesCreatedDate = createdDateFilter
      ? moment(quote.created_at).format('YYYY-MM-DD').includes(createdDateFilter)
      : true;

    const matchesCreatedBy = createdByFilter
      ? `${quote.created_by} ${quote.created_by_lastname}`.toLowerCase().includes(createdByFilter)
      : true;

    return (
      matchesCompanyName &&
      matchesSolutionType &&
      matchesTimeline &&
      matchesPrice &&
      matchesValue &&
      matchesCreatedDate &&
      matchesCreatedBy
    );
  });
  
  
  return (
    <div className="user-types-container">
      <h2>Quotes List</h2>
      <div className="filter-icon-container">
        <FaFilter
          className="filter-icon"
          onClick={() => setShowFilters(!showFilters)}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="table-container">
        <table className="user-types-table">
          <thead>
            <tr>
              <th>Sl.No.</th>
              <th>Company</th>
              <th>Solution</th>
              <th>Timeline</th>
              <th>Price</th>
              <th>PDF Attachment</th>
              <th>Created Date & Time</th>
              <th>Created By</th>
            </tr>
            {showFilters && (
              <tr className="filter-input-row">
                <th></th>
                <th>
                  <input
                    type="text"
                    value={filterCompanyName}
                    onChange={(e) => setFilterCompanyName(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    value={filterSolutionType}
                    onChange={(e) => setFilterSolutionType(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    value={filterTimeline}
                    onChange={(e) => setFilterTimeline(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    value={filterPrice}
                    onChange={(e) => setFilterPrice(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    value={filterCreatedDate}
                    onChange={(e) => setFilterCreatedDate(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    value={filterCreatedBy}
                    onChange={(e) => setFilterCreatedBy(e.target.value)}
                    placeholder="Filter"
                  />
                </th>
              </tr>
            )}
          </thead>
          <tbody>
            {filteredQuotes.map((quote, index) => (
              <tr key={quote.id} className="table-row">
                <td>{index + 1}</td>
                <td>{quote.company_name}</td>
                <td>{quote.solution}</td>
                <td>{quote.time}</td>
                <td>{quote.price}</td>
                <td>
                  <a href="#" onClick={(e) => handleDownload(e, quote.pdfUrl)}>
                    <FaFilePdf className="pdf-icon" />
                  </a>
                </td>
                <td>{moment(quote.created_at).local().format('YYYY-MM-DD HH:mm:ss')}</td>
                <td>
                  {quote.created_by} {quote.created_by_lastname}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Notification
        message={notificationMessage}
        show={showNotification}
        onClose={handleNotificationClose}
      />
    </div>
  );
}